export default __webpack_public_path__ + "static/cloud_cost_efficiency-5c0fceaa1a59e3c99bb438982d30d3ab.webp";